<template>
  <div class="sort-wrapper">
    <BaseButton
      variant="outline"
      size="sm"
      class="sort-button"
      :class="{ active: sortKey === 'symbol' }"
      @click="handleClick('symbol')"
    >
      <span>{{ $t('markets.sortSymbol') }}</span>
      <span v-if="sortKey === 'symbol'" class="sort-arrow">
        {{ sortDirection === 'asc' ? '↑' : '↓' }}
      </span>
    </BaseButton>

    <BaseButton
      variant="outline"
      size="sm"
      class="sort-button"
      :class="{ active: sortKey === 'price' }"
      @click="handleClick('price')"
    >
      <span>{{ $t('markets.sortPrice') }}</span>
      <span v-if="sortKey === 'price'" class="sort-arrow">
        {{ sortDirection === 'asc' ? '↑' : '↓' }}
      </span>
    </BaseButton>

    <BaseButton
      variant="outline"
      size="sm"
      class="sort-button"
      :class="{ active: sortKey === 'change24h' }"
      @click="handleClick('change24h')"
    >
      <span>{{ $t('markets.sort24h') }}</span>
      <span v-if="sortKey === 'change24h'" class="sort-arrow">
        {{ sortDirection === 'asc' ? '↑' : '↓' }}
      </span>
    </BaseButton>

    <BaseButton
      variant="outline"
      size="sm"
      class="sort-button"
      :class="{ active: sortKey === 'volume24h' }"
      @click="handleClick('volume24h')"
    >
      <span>{{ $t('markets.sortVolume') }}</span>
      <span v-if="sortKey === 'volume24h'" class="sort-arrow">
        {{ sortDirection === 'asc' ? '↑' : '↓' }}
      </span>
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from './BaseButton.vue'

export default {
  name: 'MarketSortBar',
  components: { BaseButton },
  props: {
    sortKey: {
      type: String,
      required: true
    },
    sortDirection: {
      type: String,
      required: true
    }
  },
  emits: ['update:sortKey', 'update:sortDirection'],
  setup(props, { emit }) {
    const handleClick = (key) => {
      if (props.sortKey === key) {
        const nextDirection = props.sortDirection === 'asc' ? 'desc' : 'asc'
        emit('update:sortDirection', nextDirection)
      } else {
        emit('update:sortKey', key)
        const defaultDirection = key === 'symbol' ? 'asc' : 'desc'
        emit('update:sortDirection', defaultDirection)
      }
    }

    return {
      handleClick
    }
  }
}
</script>

<style scoped>
.sort-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm);
}

.sort-button {
  flex: 1;
  justify-content: center;
  padding-inline: var(--spacing-md);
  border-radius: 10px;
  font-size: 11px;
  background: var(--color-bg-card); /* темнее основного фона */
  border-color: transparent;
  white-space: nowrap;
}

.sort-button.active {
  border-color: var(--color-accent);
  color: var(--color-accent);
  box-shadow: 0 0 0 1px rgba(118, 223, 198, 0.25);
  background: rgba(118, 223, 198, 0.08);
}

.sort-arrow {
  font-size: 12px;
}
</style>


